import { render, staticRenderFns } from "./SpaceManagerOfferDetail.vue?vue&type=template&id=77e5ae64&scoped=true"
import script from "./SpaceManagerOfferDetail.vue?vue&type=script&lang=js"
export * from "./SpaceManagerOfferDetail.vue?vue&type=script&lang=js"
import style0 from "./SpaceManagerOfferDetail.vue?vue&type=style&index=0&id=77e5ae64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e5ae64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
